import { render, staticRenderFns } from "./CUDocumentForm.vue?vue&type=template&id=42ef7c18&scoped=true"
import script from "./CUDocumentForm.vue?vue&type=script&lang=js"
export * from "./CUDocumentForm.vue?vue&type=script&lang=js"
import style0 from "./CUDocumentForm.vue?vue&type=style&index=0&id=42ef7c18&prod&scoped=true&lang=css"
import style1 from "./CUDocumentForm.vue?vue&type=style&index=1&id=42ef7c18&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ef7c18",
  null
  
)

export default component.exports